import { render, staticRenderFns } from "./ShiftVDPFactForm.vue?vue&type=template&id=221d7811&"
import script from "./ShiftVDPFactForm.vue?vue&type=script&lang=ts&"
export * from "./ShiftVDPFactForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports